<template>
  <div>
    <page-header
      :page="pageConfig"
      :actions="pageActionConfig"
      :left-side-class="'col-xl-8'"
      :right-side-class="
        'col-xl-4 align-items-end d-flex pb-2 justify-content-end'
      "
    />
    <Board :details="requestInfo" />
    <div v-if="model.tapRequestTransfers.length">
      <div v-for="(item, i) in model.tapRequestTransfers" :key="i" class="mt-2">
        <CustomCallout border-color="chardonnay" :has-toggle="false">
          <template #default>
            <div
              class="row py-3 pr-4 ml-md-n4"
              :style="{ 'min-height': '140px' }"
            >
              <div class="col-12 col-md-2 pl-0 border-right text-center">
                <span
                  class="px-3 py-2 rounded-pill bg-chardonnay font-14 font-weight-bold"
                  v-text="item.statusDescription"
                />
              </div>
              <div class="col mt-2 mt-md-0">
                <div class="row">
                  <div class="col-12 col-sm-6 col-md-3 mt-2 mt-md-1">
                    <div class="regular text-gray">Ocurrido:</div>
                    <span
                      class="regular"
                      v-text="dateFormat(item.createdDate)"
                    />
                  </div>
                  <div class="col-12 col-sm-6 col-md-3 mt-2 mt-md-1">
                    <div class="regular text-gray">
                      Compañía:
                    </div>
                    <span class="regular" v-text="item.companyName || '-'" />
                  </div>
                  <div class="col-12 col-sm-6 col-md-3 mt-2 mt-md-1">
                    <div class="regular text-gray">
                      Centro:
                    </div>
                    <span class="regular" v-text="item.centerName || '-'" />
                  </div>
                  <div class="col-12 col-sm-6 col-md-3 mt-2 mt-md-1">
                    <div class="regular text-gray">
                      Cambiado por:
                    </div>
                    <span class="regular" v-text="item.createdBy || '-'" />
                  </div>
                  <div class="col-12 mt-2 d-none d-md-block" />
                  <div class="col-12 col-sm-6 col-md-3 mt-2 mt-md-1">
                    <div class="regular text-gray">
                      Fecha de comienzo:
                    </div>
                    <span
                      class="regular"
                      v-text="dateFormat(item.effectiveDate)"
                    />
                  </div>
                  <div class="col-12 col-sm-6 col-md-3 mt-2 mt-md-1">
                    <div class="regular text-gray">
                      Maestro:
                    </div>
                    <span class="regular" v-text="item.teacherName || '-'" />
                  </div>
                  <div class="col-12 col-sm-6 col-md-3 mt-2 mt-md-1">
                    <div class="regular text-gray">
                      Asistente de Servicio:
                    </div>
                    <span
                      class="regular"
                      v-text="item.serviceAssistantName || '-'"
                    />
                  </div>
                </div>
              </div>
            </div>
          </template>
        </CustomCallout>
      </div>
    </div>
    <div v-else>
      <CustomResultNotFound text="No hay información disponible." />
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import Board from 'Board';
import CustomCallout from 'custom-callout';
import CustomResultNotFound from 'custom-result-not-found';
import moment from 'moment';
import { getTransferHistory as _getTransferHistory } from '@/services/api/tapRequest.api.js';

export default {
  name: 'TransferHistory',
  components: {
    PageHeader,
    Board,
    CustomCallout,
    CustomResultNotFound,
  },
  data: () => ({
    model: {
      alternativeLocation: {
        alternativeLocationCategory: {
          id: null,
          name: null,
        },
        numberOfStudents: {
          id: null,
          name: null,
        },
        grade: {
          id: null,
          name: null,
        },
      },
      serviceTypeName: null,
      studentSieId: null,
      studentName: null,
      requestNumber: null,
      dateFrom: null,
      dateTo: null,
      teacherName: null,
      serviceAssistantName: null,
      tapRequestTransfers: [],
    },
    tapRequestTransfers: {
      effectiveDate: null,
      createdDate: null,
      createdBy: null,
      companyName: null,
      centerName: null,
      statusDescription: null,
      statusId: null,
    },
    requestId: null,
    academicYearId: null,
    companyId: null,
    isReadOnly: null,
  }),
  computed: {
    pageConfig() {
      return {
        icon: 'fas fa-user-edit',
        title: 'Historial de Traslado',
        routes: [
          'Inicio',
          'Manejo de Solicitud de Asistencia Técnica de Ubicación del Estudiante',
          'Historial de Traslado',
        ],
      };
    },
    pageActionConfig() {
      return [
        {
          text: 'Regresar',
          icon: 'fas fa-arrow-circle-left',
          variant: 'outline-success',
          click: () => this.$router.go(-1),
        },
      ];
    },
    requestInfo() {
      return [
        [
          {
            label: 'Estudiante:',
            data: this.studentNameConcat(),
            icon: 'fas fa-address-book',
            cols: 'col-12 col-md-3',
          },
          {
            label: 'Tipo de Servicio:',
            data: this.model?.serviceTypeName,
            icon: 'fas fa-ballot-check',
            cols: 'col-12 col-md-3',
          },
          {
            label: 'Nombre de Alternativa:',
            data:
              this.model?.alternativeLocation?.alternativeLocationCategory
                ?.name ?? '-',
            icon: 'fas fa-ballot-check',
            cols: 'col-12 col-md-3',
          },
          {
            label: 'Cantidad de Estudiantes:',
            data:
              this.model?.alternativeLocation?.numberOfStudents?.name ?? '-',
            icon: 'fas fa-user-friends',
            cols: 'col-12 col-md-3',
          },
          {
            label: 'Número de Solicitud:',
            data: this.model?.requestNumber,
            icon: 'fas fa-ballot-check',
            cols: 'col-12 col-md-3',
          },
          {
            label: 'Fecha desde:',
            data: this.dateFormat(this.model?.dateFrom),
            icon: 'fas fa-calendar-edit',
            cols: 'col-12 col-md-3',
          },
          {
            label: 'Fecha hasta:',
            data: this.dateFormat(this.model?.dateTo),
            icon: 'fas fa-calendar-edit',
            cols: 'col-12 col-md-3',
          },
          {
            label: 'Grado:',
            data: this.model?.alternativeLocation?.grade?.name ?? '-',
            icon: 'fas fa-user-friends',
            cols: 'col-12 col-md-3',
          },
        ],
      ];
    },
  },
  async mounted() {
    const { id, academicYearId, companyId } = this.$route.params;
    this.requestId = id;
    this.academicYearId = academicYearId;
    this.companyId = companyId;

    await this.getTransferHistory();
  },
  methods: {
    async getTransferHistory() {
      const { data } = await _getTransferHistory(this.requestId);
      if (data) {
        this.model = {
          ...this.model,
          ...data,
        };
      }
    },
    studentNameConcat() {
      let nameConcat = '';
      if (this.model?.studentSieId != null && this.model?.studentName) {
        nameConcat = this.model?.studentSieId + ' - ' + this.model?.studentName;
      }
      return nameConcat;
    },
    dateFormat: function(date) {
      if (date) {
        return moment(date)
          .locale('es')
          .format('DD/MMM/YYYY');
      }
      return '-';
    },
  },
};
</script>

<style scoped lang="scss">
@use "sass:map";
@import '@/assets/scss/variables/_colors.scss';
</style>
